<template>
  <v-card
    
    :loading="loading"
  >
    <v-card-title primary-title>
      <div>
        <span>{{ title }}</span>
        <div
          class="display-3 grey--text"
          v-if="loading"
        >...</div>
        <div
          class="display-3 grey--text"
          v-else-if="error"
        >שגיאה</div>
        <div
          class="display-3"
          v-else
        >{{ formatter ? formatter(number) : number }}</div>
      </div>
    </v-card-title>
    <v-card-actions>
      <v-btn
        text
        :to="linkTo"
        color="primary"
        class="body-1"
      >{{ actionButton }}
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },

  computed: {},

  props: [
    "title",
    "linkTo",
    "actionButton",
    "number",
    "formatter",
    "loading",
    "error"
  ],

  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
